import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { AppState } from '../../store/redux/types'
import { activateAccount, AuthState } from '../../store/redux/slices/authSlice'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RegionApiCodes } from '../../types/types'
import ActionPage from './ActionPage'
import useSetLanguage from '../../hooks/useSetLanguage'

interface ActivateAccountParams {
  regionApiCode: RegionApiCodes
  email: string
  token: string
}

interface Payload {
  response: {
    status: number
  }
}

const ActivateAccount: React.FC = () => {
  const dispatch = useAppDispatch()
  const { isLoading } = useSelector((state: AppState): AuthState => state.auth)
  const { regionApiCode, email, token } = useParams<ActivateAccountParams>()
  const [message, setMessage] = useState('')
  const { t } = useTranslation()
  useSetLanguage(regionApiCode)

  const hasTriedToActivate = useRef(false)
  useEffect(() => {
    if (!hasTriedToActivate.current) {
      hasTriedToActivate.current = true
      dispatch(activateAccount({ regionApiCode, email, token }))
        .then((result) => {
          if (result.meta.requestStatus === 'fulfilled') {
            setMessage(t('activate.success'))
          } else {
            const payload: Payload = result.payload as Payload
            switch (payload.response.status) {
              case 400:
                setMessage(t('activate.notFound'))
                break
              case 409:
                setMessage(t('activate.alreadyActivated'))
                break
              default:
                setMessage(t('activate.error'))
                break
            }
          }
          return
        })
        .catch(() => {
          console.error('Error')
        })
    }
  }, [email, token, dispatch, t, regionApiCode])

  return <ActionPage message={message} isLoading={isLoading} title={t('activate.title')} />
}

export default ActivateAccount
